import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import PageNotFound from "../components/page-not-found";
import Login from "../components/login";
import { LoginCallback } from "../auth";

const UnauthenticatedApp = () => {
    return (
        <Switch>
            <Route exact path="/" component={Login} />
            <Route exact path="/thank-you">
                <Redirect to="/" />
            </Route>
            <Route exact path="/login" component={LoginCallback} />
            <Route component={PageNotFound} />
        </Switch>
    );
};

export default UnauthenticatedApp;
